import React, { useEffect, useState } from 'react';
import '../Css_files/Homecont3.css';

const HomeCont3 = () => {
  const [counts, setCounts] = useState({
    learners: 0,
    projects: 0,
    courses: 0,
    trainers: 0,
  });

  useEffect(() => {
    const target = {
      learners: 2000,
      projects: 250,
      courses: 100,
      trainers: 120,
    };

    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    let currentStep = 0;

    const intervalId = setInterval(() => {
      currentStep++;
      setCounts({
        learners: Math.min(Math.floor((target.learners / steps) * currentStep), target.learners),
        projects: Math.min(Math.floor((target.projects / steps) * currentStep), target.projects),
        courses: Math.min(Math.floor((target.courses / steps) * currentStep), target.courses),
        trainers: Math.min(Math.floor((target.trainers / steps) * currentStep), target.trainers),
      });

      if (currentStep >= steps) clearInterval(intervalId);
    }, interval);
  }, []);

  return (
    <div className="homecont3">
      <div className="homecont3-wrapper">
        <div className="homecont3-heading">
          <h2>Our Achievements</h2>
        </div>
        <div className="counter-container">
          <div className="counter-box">
            <i className="icon">💙</i>
            <h2>{counts.learners}+</h2>
            <p>Satisfied Learners</p>
          </div>
          <div className="counter-box">
            <i className="icon">🧩</i>
            <h2>{counts.projects}</h2>
            <p>Realtime Projects</p>
          </div>
          <div className="counter-box">
            <i className="icon">📘</i>
            <h2>{counts.courses}+</h2>
            <p>Courses</p>
          </div>
          <div className="counter-box">
            <i className="icon">👥</i>
            <h2>{counts.trainers}</h2>
            <p>Certified Trainers</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCont3;
